import React from 'react';
import '../../styles/SearchBar.css';

const SearchBar = () => {
  return (
    <div className="search-container">
      <form className="search-form">
        <input type="text" placeholder="Buscar produtos..." className="search-input" />
        <button type="button" className="search-button">
          <i className="fas fa-search"></i>
        </button>
      </form>
    </div>
  );
};

export default SearchBar;